import { hits, type Style } from '../style';

/** Asakaa (Kumasi drill): sliding 808s, half-time snare, rolling hats, a dark bell melody. */
const MELODY = [67, 0, 0, 70, 0, 0, 72, 0, 70, 0, 0, 67, 0, 0, 63, 0];

export const ASAKAA: Style = {
  bpm: 142,
  swing: 0,
  play(kit, step, bar, t, len, energy) {
    if (hits('x.........x.....', step)) kit.kick(t);
    if (step === 8) kit.clap(t, 0.9);
    const roll = energy > 0.5 && step >= 12 && bar % 2 === 1;
    if (step % 2 === 0 || roll) kit.hat(t, false, roll ? 0.7 : 0.6);
    if (step === 0) kit.sub(t, 39, len * 7, bar % 2 === 0 ? 39 : 43);
    if (step === 11) kit.sub(t, 41, len * 4, 36);
    const note = MELODY[step] ?? 0;
    if (note) kit.pluck(t, note, 0.5);
  },
};
